// VerifyEmail.tsx

import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyEmail, getMe } from '../../../services/api';
import { AuthContext } from '../../../components/auth/AuthContext';
import { LoadingContext } from '../../../contexts/LoadingContext';
import { handleError } from '../../../utils/errorUtils';
import { identifyUser, captureEvent } from '../../../services/analytics';
import { setMonitoringUser } from '../../../services/monitoring';
import { startSession } from '../../../utils/authUtils';



const VerifyEmail: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAccessToken, setUserId } = useContext(AuthContext);
  const { setIsLoading } = useContext(LoadingContext);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const verifyEmailToken = async () => {
      try {
        setIsLoading(true);

        if (token) {
            const verifyEmailResponse = await verifyEmail(token);
            console.info("User Email Verified. Verification Id: " + verifyEmailResponse.verificationID)
            
            // Store the User Id
            setUserId(verifyEmailResponse.userID);
            localStorage.setItem('userId', verifyEmailResponse.userID);

            // Store the access token in the context and localStorage
            setAccessToken(verifyEmailResponse.accessToken);
            startSession(verifyEmailResponse.accessToken, verifyEmailResponse.accessTokenExpiration);

            // Store user details
            const getMeResponse = await getMe();
            localStorage.setItem('userFirstName', getMeResponse.firstName);
            localStorage.setItem('userRole', getMeResponse.role);

            identifyUser(verifyEmailResponse.userID, { role: getMeResponse.role });
            setMonitoringUser({ id: verifyEmailResponse.userID, role: getMeResponse.role });
            captureEvent('email_verified');

            navigate('/registration/confirmation-thank-you');
        } else {
          console.error('Token not found in URL');
        }
      } catch (error) {
        handleError(error);
        if (
          error instanceof Error &&
          (error as any).response &&
          (error as any).response.status === 409
        ) {
          navigate('/');
        }
      }

      finally{
        setIsLoading(false);
      }
    };

    verifyEmailToken();
    // The three setters are safe to list rather than suppress: setAccessToken
    // and setUserId are the raw useState setters AuthProvider puts on the
    // context (AuthContext.tsx), setIsLoading likewise from LoadingProvider,
    // and React guarantees a useState setter keeps its identity for the life of
    // the component — so this array still only changes when the URL does, and
    // the POST /api/v1/users/registrations/verifications it fires stays once.
  }, [location.search, navigate, setAccessToken, setUserId, setIsLoading]);

  return null;
};

export default VerifyEmail;
